import { BB2020Carac } from "enefel/player";
import { getCareerFromPlayer } from "enefel/race";
import React from "react";
import styled from "styled-components";

const Wrapper = styled.span`
  font-weight: bold;
  text-shadow: 1px 1px 1px black;
`;
const WrapperLess = styled.span`
  font-weight: normal;
  color: red;
`;

type PlayerCharacProps = {
  prop: any;
  player: any;
  color?: string;
};

const PlayerCharac: React.FC<PlayerCharacProps> = React.memo(
  ({ prop, player, color = "red" }) => {
    const career = getCareerFromPlayer(player);
    const careerVersion = career?.version;
    let carac = player[prop];
    if (carac == null) {
      return null;
    }
    if (career && career[prop]) {
      if (career[prop] < carac) {
        return <Wrapper>{BB2020Carac(carac, prop, careerVersion)}</Wrapper>;
      }
      if (career[prop] > carac) {
        return (
          <WrapperLess>{BB2020Carac(carac, prop, careerVersion)}</WrapperLess>
        );
      }
    }
    return <>{BB2020Carac(carac, prop, careerVersion)}</>;
  }
);
export default PlayerCharac;
